var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "login-page" },
    [
      _c(
        "el-header",
        [
          _c("h1", [_vm._v("月亮湾")]),
          _vm._v(" "),
          _c("el-button", { staticClass: "register", attrs: { plain: "" } }, [
            _vm._v("注册")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("el-main", [
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "main" }, [
            _c("div", { staticClass: "left" }, [
              _c("img", {
                attrs: { src: require("../assets/pic_login.jpg"), alt: "" }
              })
            ]),
            _vm._v(" "),
            _vm.type == "forget"
              ? _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c("h3", [_vm._v("欢迎使用月亮湾魔盒")]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("忘记密码")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: { placeholder: "请输入手机号" },
                            model: {
                              value: _vm.phone,
                              callback: function($$v) {
                                _vm.phone = $$v
                              },
                              expression: "phone"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "area_code",
                              attrs: { slot: "prepend", disabled: true },
                              slot: "prepend",
                              model: {
                                value: _vm.area_code,
                                callback: function($$v) {
                                  _vm.area_code = $$v
                                },
                                expression: "area_code"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: { placeholder: "请输入验证码" },
                            model: {
                              value: _vm.code,
                              callback: function($$v) {
                                _vm.code = $$v
                              },
                              expression: "code"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "append",
                                  type: _vm.second <= 0 ? "success" : "info"
                                },
                                on: { click: _vm.getCode },
                                slot: "append"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.second <= 0
                                      ? "发送验证码"
                                      : _vm.second + "s"
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "login",
                        attrs: { type: "success" },
                        on: { click: _vm.toNew }
                      },
                      [_vm._v("重置密码")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _vm._v("记起密码？"),
                      _c(
                        "span",
                        { staticClass: "green", on: { click: _vm.toLogin } },
                        [_vm._v("立即登录")]
                      )
                    ])
                  ],
                  1
                )
              : _vm.type == "new"
              ? _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c("h3", [_vm._v("欢迎使用月亮湾魔盒")]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("设置新密码")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("div", { staticClass: "label" }, [_vm._v("新密码")]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入新密码",
                            "show-password": ""
                          },
                          model: {
                            value: _vm.npsw,
                            callback: function($$v) {
                              _vm.npsw = $$v
                            },
                            expression: "npsw"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("确认新密码")
                        ]),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            placeholder: "请再次输入新密码",
                            "show-password": ""
                          },
                          model: {
                            value: _vm.apsw,
                            callback: function($$v) {
                              _vm.apsw = $$v
                            },
                            expression: "apsw"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "login",
                        attrs: { type: "success" },
                        on: { click: _vm.toReset }
                      },
                      [_vm._v("重置密码")]
                    )
                  ],
                  1
                )
              : _vm.type == "choice"
              ? _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c("h3", [_vm._v("欢迎使用月亮湾魔盒")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.choiceValue,
                              callback: function($$v) {
                                _vm.choiceValue = $$v
                              },
                              expression: "choiceValue"
                            }
                          },
                          [
                            _c("el-radio-button", {
                              staticClass: "w50 h60",
                              attrs: { label: "管理端" }
                            }),
                            _vm._v(" "),
                            _c("el-radio-button", {
                              staticClass: "w50 h60",
                              attrs: { label: "客户端" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.choiceValue == "客户端"
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择客户" },
                                model: {
                                  value: _vm.customerValue,
                                  callback: function($$v) {
                                    _vm.customerValue = $$v
                                  },
                                  expression: "customerValue"
                                }
                              },
                              _vm._l(_vm.customerOptions, function(item) {
                                return _c("el-option", {
                                  key: item.client_id,
                                  attrs: {
                                    label: item.client_name,
                                    value: item.client_id
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "login",
                        attrs: { type: "success" },
                        on: { click: _vm.choiceClick }
                      },
                      [_vm._v("确认")]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c("h3", [_vm._v("欢迎使用月亮湾魔盒")]),
                    _vm._v(" "),
                    _c("h4"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: { placeholder: "请输入手机号" },
                            model: {
                              value: _vm.phone,
                              callback: function($$v) {
                                _vm.phone = $$v
                              },
                              expression: "phone"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "area_code",
                              attrs: { slot: "prepend", disabled: true },
                              slot: "prepend",
                              model: {
                                value: _vm.area_code,
                                callback: function($$v) {
                                  _vm.area_code = $$v
                                },
                                expression: "area_code"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入密码",
                            "show-password": ""
                          },
                          model: {
                            value: _vm.psw,
                            callback: function($$v) {
                              _vm.psw = $$v
                            },
                            expression: "psw"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 4, offset: 20 } },
                          [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.toForget }
                              },
                              [_vm._v("忘记密码")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row agreement-row" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.agreeProtocol,
                              callback: function($$v) {
                                _vm.agreeProtocol = $$v
                              },
                              expression: "agreeProtocol"
                            }
                          },
                          [
                            _vm._v(
                              "\n              我已阅读并同意\n              "
                            ),
                            _c(
                              "el-link",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.showUserAgreement }
                              },
                              [_vm._v("《用户服务协议》")]
                            ),
                            _vm._v("\n              和\n              "),
                            _c(
                              "el-link",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.showPrivacyPolicy }
                              },
                              [_vm._v("《隐私协议》")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "login",
                        attrs: { type: "success" },
                        on: { click: _vm.goLogin }
                      },
                      [_vm._v("登录")]
                    )
                  ],
                  1
                )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26084dc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26084dc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = null
// module chunks = 